<template>
  <div class="subMenu">
    <v-navigation-drawer v-if="submenu.length > 2" v-model="drawer" permanent clipped color="secondary" expand-on-hover>
      <v-list dense nav>
        <template v-for="item in submenu">
          <v-list-group
            v-if="item.items.length"
            :key="item.title"
            :value="item.title === $root.currentPage"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icon ? item.icon : 'mdi-file-account-outline' }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </template>

            <v-list>
              <v-list-item
                v-for="subItem in item.items"
                :key="subItem.title"
                :to="subItem.to"
                link
                class="ml-6"
              >
                <v-list-item-icon>
                  <v-icon>{{ subItem.icon ? subItem.icon : 'mdi-file-account-outline' }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-list-group>
          <v-list-item v-else :key="item.title" :to="item.to" link class="submenuItem">
            <v-list-item-icon>
              <v-icon>{{ item.icon ? item.icon : 'mdi-file-account-outline' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<!--
<template>
  <div class="submenu">
    <span v-for="item in submenu" :key="item.title">
      <v-menu v-if="item.items.length" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            plain
            class="submenuItem"
            v-bind="attrs"
            v-on="on"
            :class="{ 'v-btn--active': $root.currentPage === item.title }"
          >
            {{ item.title }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="subItem in item.items" :key="subItem.title" :to="subItem.to" link>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn v-else :to="item.to" link plain class="submenuItem">{{ item.title }}</v-btn>
    </span>
  </div>
</template>
-->

<script>
export default {
  name: 'SubMenu',
  data: () => ({
    drawer: true,
  }),
  computed: {
    selectedMemberId() {
      return this.$store.getters.selectedMemberId;
    },
    submenu() {
      let submenu = [];
      const menu = this.$store.getters.menu;
      if (menu && this.$route) {
        let rootMenuItem = menu.find((x) => {
          const selected = x.items.find((x) => {
            if (x.items.length) {
              return x.items.find((y) => y.to == this.$route.path);
            }
            return x.to == this.$route.path;
          });
          if (selected) {
            return true;
          }
          return false;
        });

        if (rootMenuItem) {
          if (rootMenuItem.title == 'Members') {
            submenu = this.selectedMemberId
              ? rootMenuItem.items.filter((x) => {
                  return x.title != 'Search';
                })
              : rootMenuItem.items.filter((x) => {
                  return x.title == 'Member Details';
                });

            submenu = rootMenuItem.items;
          } else {
            submenu = rootMenuItem.items;
          }
        }
      }

      return submenu;
    },
    currentPage() {
      console.log(this.$root.currentPage);
      return this.$root.currentPage;
    },
  },
};
</script>

<style lang="scss">
.subMenu {
  height:100%;
  flex-grow: 0;
}

/*.subMenu {
  width: 100%;
  padding: 10px;
  font-family: Roboto;

  .submenuItem {
    color: #4a1cd4;
    font-weight: bold;
    margin-right: 5px;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .submenuItem[aria-expanded='true'] {
    .v-icon {
      transform: rotate(180deg);
    }
  }
  .v-btn--active {
    border-bottom: 2px solid #4a1cd4;
    border-radius: inherit;
  }

  .subMenuBar {
    margin-bottom: 10px;
  }*/

</style>
